module.exports = __webpack_public_path__ + "img/contact.65a60b9d.jpg";